import { OOT_GLOBAL, DATAMART_GLOBAL, OOT_CONFIGURATOR } from "Components/Misc/CaseDetails_System";
import { showModal } from "Store/auth";
import axios from "axios";
import { PublicClientApplication, type Configuration } from "@azure/msal-browser";
import { msalConfig } from "authConfig";
//https://corsproxy.io/? if this is the issue lets this will integrate from the OOT.
import { store } from "Store/mainStore";
import { TYPE_OF_BUNDLE } from "Pages/marketplace/Utils/BundleHelper";
import { applyApiTimeout } from "Constants/services/axiosApiTimeout";

type RedX = { dispatch: (action: unknown) => void };

class OOT_API {
  accessToken: string | undefined;
  email: string | undefined;
  idtoken: string | undefined;
  userID: string | undefined;
  redX: RedX | undefined;
  constructor() {
    this.interceptRequests();
  }
  init({
    accessToken,
    email,
    idtoken,
    userID,
    redX,
  }: {
    accessToken: string;
    email: string;
    idtoken: string;
    userID: string;
    redX: RedX;
  }) {
    if (accessToken && email) {
      this.accessToken = accessToken;
      this.email = email;
      this.idtoken = idtoken;
      this.userID = userID;
      this.redX = redX;
    } else {
      return { msg: "Failed to initiate." };
    }
  }
  interceptRequests() {
    axios.interceptors.response.use(
      (response) => {
        const skipGlobalErrorDialog = Boolean((response.config as any)?._skipGlobalErrorDialog);

        if (skipGlobalErrorDialog) {
          return response;
        }

        // Skip error handling for file download responses (blob responses)
        if (response.config.responseType === 'blob') {
          return response;
        }
        if (
          parseInt(response.data.errorCode) === 401 &&
          (response.data.errorMessage
            .trim()
            .toUpperCase()
            .includes("TOKEN ERROR") ||
            response.data.errorMessage
              .trim()
              .toUpperCase()
              .includes("TOKEN EXPIRED"))
        ) {
          this.redX?.dispatch(
            showModal({
              msg: "Please log in again now...",
              variant: "ERROR",
              title: response.data.errorMessage.trim().toUpperCase(),
              show: true,
            })
          );
          // Save current state
          this.setCurrentState();
          // Show the message 5 second and redirect the page to login
          setTimeout(() => {
            const msalInstance = new PublicClientApplication(
              msalConfig as Configuration,
            );
            //@ts-ignore
            msalInstance.loginRedirect({
              redirectStartPage: process.env.REACT_APP_REDIRECT_URI,
            });
          }, 3000);
        } else if (parseInt(response.data.errorCode) === 401) {
          this.speak(401, {
            msg: response.data.errorMessage ? response.data.errorMessage : "Permission for this page/data is denied",
            panel: { title: "More details", msg: response.data.stacktrace || "" },
          });
        }
        else if (parseInt(response.data.errorCode) === 500) {
          this.speak(401, {
            msg: response.data.errorMessage ? response.data.errorMessage : "Permission for this page/data is denied",
            panel: { title: "More details", msg: response.data.stacktrace || "" },
          });
        }
        // Check for error conditions in different response formats
        const hasStatusError = response.data?.event_type && response.data.event_type === "deeplink_access_check" ? false : response.data.hasOwnProperty('status') && !response.data.status;
        const hasResponseStatusError = response.data.hasOwnProperty('response_status') && !response.data.response_status;

        if ((hasStatusError || hasResponseStatusError) && response?.data?.status !== null) {
          this.speak(500, {
            msg: response.data.errorMessage,
            panel: { title: "More details", msg: response.data.stacktrace || "" },
          });
        }
        return response;
      },
      (error) => {
        const skipGlobalErrorDialog = Boolean((error.config as any)?._skipGlobalErrorDialog);

        if (skipGlobalErrorDialog) {
          return Promise.reject(error);
        }

        // Skip error handling for file download requests (blob responses)
        // if (error.config && error.config.responseType === 'blob') {
        //   return Promise.reject(error);
        // }

         // Return API response directly only for bulk-upload API
          if (
            error.name === "AxiosError" && error.response?.status === 400 &&
            error.response?.config?.url?.includes(
              "v2/network/contacts/bulk-upload"
            ) &&
            error.response?.data
          ) {
            return Promise.resolve(error.response.data);
          }

        const info = { msg: error, panel: { title: "", msg: "" } };
        if (error.name === "AxiosError") {
          if (error.response && error.response.data) {
            if (error.response.data.errorCode === 401) {
              info.msg = error.response.data.errorMessage;
              info.panel.title = "Permission for this page/data is denied";
              info.panel.msg = error.response.data.stacktrace;
            } else {
              info.msg = error?.response?.data?.data?.errorMessage || error?.response?.data?.errorMessage || "Something went wrong";
              info.panel.title = "Something went wrong";
              info.panel.msg = error?.response?.data?.stacktrace || "";
            }
          } else {
            // Handle unexpected Axios errors
            console.warn("AxiosError: ", error);
            info.msg = error.name;
            info.panel.title = error.message;
            let userMessage = "Something went wrong. Please try again.";

            if (error.code === "ECONNABORTED") {
              userMessage = "The request took too long and timed out. Please try again later.";
            }
            info.panel.msg = userMessage;
          }
        }
        this.speak(500, info);
        return Promise.reject(error);
      }
    );
    axios.interceptors.request.use((request) => {
      // console.log(request, '*********')
      // if(request.url.includes('/offer') && request.method === 'post'){
      //   request.headers["Content-Type"] = "multipart/form-data";
      // }else{
      //   request.headers["Content-Type"] = "application/json; charset=UTF-8";
      // } 

      if ((
          request.url?.includes('/offer') && request.method === 'post') || 
          (request.url?.includes('/upload') && request.method === 'post') || 
          (request.url?.includes('/file_upload') && request.method === 'post') || 
          (request.url?.includes('/v3/import/product') && request.method === 'post') ||
          (request.url?.includes('/v2/contract/hub/agreement') && request.method === 'put') || 
          (request.url?.includes('/v2/network/contacts/bulk-upload') && request.method === 'post')) {
        // Check if the request data includes a file
        if (request.data instanceof FormData) {
          request.headers["Content-Type"] = "multipart/form-data";
        } else {
          request.headers["Content-Type"] = "application/json; charset=UTF-8";
        }
      } else {
        request.headers["Content-Type"] = "application/json; charset=UTF-8";
      }
      if (request.headers["operation"] === 'access' || request.headers["operation"] === 'otp_validate' || request.headers["operation"] === 'otp_resend') {

      }
      else {
        request.headers["Authorization"] = "Bearer " + this.accessToken;
        delete request.headers["idtoken"];
        request.headers["idtoken"] = OOT.idtoken;
       if(this.userID && !request.url?.includes('/user?token=')) {
          request.headers['x-user-id'] = this.userID;
        }
      }
      // Timeout + bypasses: single source in axiosApiTimeout.ts
      applyApiTimeout(request);
      return request;
    });
  }
  speak(
    code: number,
    info: { msg: unknown; panel: { title: string; msg: string } } = {
      msg: "",
      panel: { title: "", msg: "" },
    },
  ) {
    switch (code) {
      case 401:
        this.redX?.dispatch(
          showModal({
            msg: "Please Reload to continue , If you have any unsaved data, close this message and copy the data before logging in again. If not, please log in again now.",
            variant: "ERROR",
            title: "Session Timed Out",
            show: true,
          })
        );
        break;
      case 200:
        break;
      case 500:
        this.redX?.dispatch(
          showModal({
            msg: info.msg,
            variant: "ERROR",
            title: "Something went wrong",
            show: true,
            panel: {
              msg: info.panel.msg,
              title: info.panel.title,
            },
          })
        );
        break;
    }
  }

  /**
   * Save current state in localstorage
   *
  */
  setCurrentState = () => {
    localStorage.setItem("dac-portal-state", JSON.stringify(store.getState()))
  }





  syncOffer = async ({ data, source = 'cui' }: any) => {
    const params = `?username=${this.email}&source=${source}`;
    const res = await axios({
      method: "post",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.syncOffer + params,
      data: data,
    });
    return res.data;
  };

  getOpportunity = async ({ scrm_id }: any) => {
    const params = `?_format=json&username=${this.email}&scrm_id=${scrm_id}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getOpportunity + params,
    });
    return res.data;
  };
  getCustomer = async ({ account_nid }: any) => {
    //this runs when scrm is invalid;
    const params = `?_format=json&username=${this.email}&account_nid=${account_nid}&requestor=marketplace`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getCustomer + params,
    });

    return res.data;
  };

  getCustomerByNid = async ({ nid }: any) => {

    //this runs when scrm is invalid;
    const params = `?_format=json&username=${this.email}&nid=${nid}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getCustomer + params,
    });

    return res.data;
  };

  getAccountCustomer = async (account_nid: any) => {
    //this runs when scrm is invalid;
    const params = `?_format=json&username=${this.email}&nid=${account_nid}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getAccountCustomer + params,
    });

    return res.data;
  };

  getCountryBands = async ({ country }: any) => {
    //this runs when scrm is invalid;
    const params = `?_format=json&country=${country}&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getCountryBands + params,
    });
    return res.data;
  };
  getProducts = async ({ category, account }: any) => {
    //this runs when scrm is invalid;
    const params = `?_format=json&category=${category}&account=${account}&username=${this.email}&flatten=true`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getProducts + params,
    });

    return res.data;
  };
  getApplicationTab = async ({ account }: any) => {
    const params = `?_format=json&account=${account}&username=${this.email}`;
    const res = await axios({
      method: "get",
      url:
        OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getApplicationTab + params,
    });

    return res.data;
  };
  getConnectivityTab = async ({ account, radioBand }: any) => {
    const params = `?_format=json&account=${account}&username=${this.email}&radioBand=${radioBand}`;
    const res = await axios({
      method: "get",
      url:
        OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getConnectivitytab + params,
    });

    return res.data;
  };

  getEdgeTab = async ({ account }: any) => {
    //http://localhost:5000/api/get-edgeTab?_format=json&username={{email}}&account=1000001115
    const params = `?_format=json&account=${account}&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getEdgeTab + params,
    });
    return res.data;
  };
  getDevicesTab = async ({ account }: any) => {
    //http://localhost:5000/api/get-deviceTab?_format=json&username={{email}}&account=1000001115
    const params = `?_format=json&account=${account}&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getDevicesTab + params,
    });
    return res.data;
  };
  getServicesTab = async ({
    account,
    caseData,
    shipping_country_code,
    currency_code,
  }: any) => {
    const params = `?_format=json&account=${account}&username=${this.email}&shipping_country_code=${shipping_country_code}&currency_code=${currency_code}`;
    // const ndacServices = new Promise((rs, rj) => {
    //   return axios({
    //     method: "POST",
    //     url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getServicesTab + params,
    //     data: caseData
    //   }).then((res) => rs(res.data));
    // })

    const res = await axios({
      method: "POST",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getServicesTab + params,
      data: caseData,
    });
    // const res = await axios.all([ndacServices, ndacProfServices]);
    return {
      //@ts-ignore
      mpw_services: res?.data.data,
      //@ts-ignore
      // ndac_professional_services: res[1].data
    };
  };

  getWarrantyTab = async ({ account }: any) => {
    const params = `?_format=json&account=${account}&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getWarrantyTab + params,
    });
    return res.data;
  };

  /**
   * Subscription Management api calls
   * @returns
   */

  getSubscriptionQuesionneries = async () => {
    //http://localhost:8080/api/subscription-questionnaire?_format=json&username={{email}}
    if (this.email) {
      const params = `?_format=json&username=${this.email}`;
      const res = await axios({
        method: "get",
        url:
          OOT_GLOBAL.proxyUrl +
          OOT_GLOBAL.endPoints.getSubscriptionQuestionnaire +
          params,
      });
      return res.data;
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };

  getSubscriptionPartnerData = async (isRequestor: any = false) => {
    //http://localhost:8080/api/network_data?_format=json&username={{email}}
    if (this.email) {
      const params = isRequestor ? `/partner?_format=json&username=${this.email}&requestor=marketplace` : `/partner?_format=json&username=${this.email}`;
      const res = await axios({
        method: "post",
        url:
          OOT_GLOBAL.proxyUrl +
          OOT_GLOBAL.endPoints.getSubscriptionNetworkData +
          params,
      });
      return res.data;
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };

  getNewSubscriptionPartnerData = async (allnetworks: any = false) => {
    //http://localhost:8080/api/network_data?_format=json&username={{email}}
    if (this.email) {
      const params = allnetworks ? `?_format=json&return_type=partner&username=${this.email}&all_networks=true` : `?_format=json&return_type=partner&username=${this.email}`;
      const res = await axios({
        method: "get",
        url:
          DATAMART_GLOBAL.baseUrl +
          DATAMART_GLOBAL.endPoints.getNewSubscriptionNetworkData +
          params,
      });
      const partnerList = [];
      if (res.data.data.result && typeof res.data.data.result === "object") {
        for (let v in res.data.data.result) {
          let obj = {
            id: v,
            value: res.data.data.result[v] ?? "-",
          };
          partnerList.push(obj);
        }
      }
      return partnerList
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };

  getSubscriptionNetworkDataList = async (isRequestor: any = false) => {
    //http://localhost:8080/api/network_data?_format=json&username={{email}}
    if (this.email) {
      const params = `?_format=json&return_type=partner&username=${this.email}`;
      const res = await axios({
        method: "get",
        url:
          DATAMART_GLOBAL.baseUrl +
          DATAMART_GLOBAL.endPoints.getNewSubscriptionNetworkData +
          params,
      });
      const partnerList = [];
      if (res.data.data.result && typeof res.data.data.result === "object") {
        for (let v in res.data.data.result) {
          let obj = {
            id: v,
            value: res.data.data.result[v] ?? "-",
          };
          partnerList.push(obj);
        }
      }
      return partnerList
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };

  getNewSubscriptionNetworkDataList = async (accountNetworkId: any,type: any,allnetwork: any=false) => {
    //http://localhost:8080/api/network_data?_format=json&username={{email}}
    if (this.email) {
      const params = type === "accountId" ? allnetwork ? `?_format=json&filter=accountnumber='${accountNetworkId}'&username=${this.email}&all_networks=true` : `?_format=json&filter=accountnumber='${accountNetworkId}'&username=${this.email}` : allnetwork ? `?_format=json&filter=network_id='${accountNetworkId}'&username=${this.email}&all_networks=true` : `?_format=json&filter=network_id='${accountNetworkId}'&username=${this.email}`;
      const res = await axios({
        method: "get",
        url:
          DATAMART_GLOBAL.baseUrl +
          DATAMART_GLOBAL.endPoints.getNewSubscriptionNetworkData +
          params,
      });
      return res
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };


  getSubscriptionNetworkData = async (accountId: any,type: any) => {
    //http://localhost:8080/api/network_data?_format=json&username={{email}}
    if (this.email) {
      const params = type === "networkId" ? `/network/${accountId}?_format=json&username=${this.email}` : `/account/${accountId}?_format=json&username=${this.email}`;
      const res = await axios({
        method: "post",
        url:
          OOT_GLOBAL.proxyUrl +
          OOT_GLOBAL.endPoints.getSubscriptionNetworkData +
          params,
      });
      return res.data;
    }
    return new Promise((resolve, reject) =>
      reject(new Error("Something went wrong"))
    );
  };

  updateSubscription = async (data: any) => {
    //http://localhost:8080/api/subscription-update?_format=json&username={{email}}
    const params = `?username=${this.email}`;
    const res = await axios({
      method: "post",
      url:
        OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.updateSubscription + params,
      data: data,
    });
    return res.data;
  };

  cancellationSubscription = async (data: any) => {
    //http://localhost:8080/api/subscription-cancellation?_format=json&username={{email}}
    const params = `?username=${this.email}`;
    const res = await axios({
      method: "post",
      url:
        OOT_GLOBAL.proxyUrl +
        OOT_GLOBAL.endPoints.cancellationSubscription +
        params,
      data: data,
    });
    return res.data;
  };

  /**
    * marketplace api calls
    * @returns
    */


  //get products data from datamart

  getAccountDetailsApi = async (one_star_id: any) => {
    const bodyParams = {
      "properties": [
        "account_master_sapbyd.account_id",
        "account_master_sapbyd.account_text",
        "account.acc_no__c",
        "account_master_currency_sapbyd.currency_id",
        "account_master_currency_sapbyd.currency_text",
        "account.billingcountry",
        "account.billingcountrycode",
        "account.currencyisocode",
        "account_master_sapbyd.one_star_id",
        "account_master_sapbyd.three_star_id",
        "account.alcr_record_type__c",
        "merchant_terms_and_conditions.terms_and_conditions",
        "account.partner_type__c",
        "account_master_sapbyd.customer_group_text",
        "account_master_sapbyd.distribution_channel_id ",
        "account_master_sapbyd.distribution_channel_text"

      ],
      "filter": "",
      "one_star_id": [one_star_id],
      "limit": 10,
      "offset": 0
    }

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getAccountData,
      data: bodyParams
    });

    return res.data;
  }

  getQuotationAPI = async (oneStarSellToParty: any,oneStarEndCustomer: any,filter: any = '',limit: any = 100,offset: any = 0,sort: any) => {
    const offerProperties = [
      "offer_header_data.offer_id",
      "offer_header_data.field_ofr_order_link_to_salesfor",
      "offer_header_data.name",
      "offer_header_data.nid",
      "offer_header_data.one_star_number_account",
      "offer_header_data.one_star_number_customer_partner",
      "offer_header_data.offer_link",
      "offer_header_data.owner_email",
      "offer_header_data.offer_title",
      "offer_header_data.offer_created_date",
      "offer_header_data.field_offer_expiry_date",
      "offer_header_data.field_ofr_order_approved_date",
      "offer_header_data.archived",
      "offer_header_data.field_ofr_order_cart_total",
      "offer_header_data.field_ofr_order_cat_prod_discoun",
      "offer_header_data.field_ofr_order_commercial_model",
      "offer_header_data.field_ofr_order_co_owners",
      "offer_header_data.field_ofr_order_currency",
      "offer_header_data.field_ofr_order_source",
      "offer_header_data.field_ofr_order_original_price",
      "offer_header_data.status",
      "offer_header_data.po_number",
      "offer_header_data.po_link_pdf_attachment_link",
      "offer_header_data.createdAt",
      "offer_header_data.oot_billing_address_id",
      "offer_header_data.oot_shipping_address_id",
      "offer_header_data.field_order_created_date",
      "offer_header_data.field_order_form_id"
    ]
    const data = {
      "properties": offerProperties,
      "filter": filter,
      "limit": limit,
      "offset": offset,
      orderBy: sort
    }
    //const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;

    const params = `?_format=json&sellToParty=${oneStarSellToParty}&endCustomer=${oneStarEndCustomer}`;
    //const url = 'http://localhost:3000/offer/getAllOffers';
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getAllOffers;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifyProductData(res.data.data)
    return res.data;
  }


  getUserAccessControlInfo = async (user_id: any,isOnboardingUser: any = false) => {
  const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.user;
  
  const headers: Record<string, string> = {
    'x-user-id': user_id,
  };
  
  // Add custom header for onboarding users
  if (isOnboardingUser) {
    headers['requested_info'] = 'partner_merchant_onboarding_details_request';
  }
  
  const response = await axios.get(url, { headers });
  return response.data;
}


  getAccountDetailsByOneStarID = async (one_star_id: any) => {
    const params = `?_format=json&username=${this.email}&1star=${one_star_id}`;
    const res = await axios({
      method: "get",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getAccountCustomer + params,
    });

    return res.data;
  }

  /* get product bundle properties */
  getProductBundleProperties = async () => {
    return [
      "compact_kits.compact_id",
      "compact_kits.compact_kit_id",
      "compact_kits.compact_id_type",
      "compact_kits.kit_products",
      "compact_kits.compact_kit_qty",
      "compact_kits.configurator_app_name",
      "compact_kits.maximum_duration",
      "compact_kits.minimum_duration",
      "compact_kits.step_size",
      "compact_kits.description",
      "compact_kits.kit_category",
      "compact_kits.mxie_required",
      "compact_kits.show_duration",
    ]
  }

  //product api
  getAllProducts = async (account_no: any,currency: any = "",filter: any = '',limitPerPage: any = 20,offset: any = 0,crosserFilterData: any = '') => {
    // get product bundle properties
    let productBundleProperties = await this.getProductBundleProperties();

    // product properties
    const productProperties = [
      "pricelist_2_0.sap_account_id",
      "pricelist_2_0.account_description",
      "pricelist_2_0.price_amount",
      "pricelist_2_0.priceamount_currencycode",
      "product_data.id",
      "product_data.product_id",
      "product_data.product_category_description",
      "product_data.product_description",
      "product_data.product_family_id",
      "product_data.product_type_id",
      "product_data.product_sub_type_id",
      "pricelist_2_0.price_list",
      "product_data.product_lifecycle_status",
      "product_data.is_agent_model",
      "product_data.image_url",
      "product_data.is_marketplace",
      "supplier_master_sapbyd.supplier_text",
      "product_supplier_data.supplier_id",
      "supplier_master_sapbyd.address_info->>'$.data[0].country_region_id'",
      "product_details.product_specifications",
      "product_details.image_base_url",
      "product_data.fulfillment_mode",
      "product_data.product_sub_category",
      "product_data.nokia_tested",
      "product_data.product_category_id",
      "product_data.technical_support_type",
      // "product_data.supplier_id"     
      // Add the productBundleProperties, add product colums above this line
      ...productBundleProperties,
    ]

    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset,
      // Bundle product inclusion flag
      "includeCompactKits": true,
      "shippingCountry": store.getState()?.marketplace?.filters?.selection?.shippingCountry || null,
      // TODO: need to work on this and should be part of passed filter
      "crosserFilter": crosserFilterData
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: url + params,
      data: data
    });
    res.data.data = this.modifyProductData(res.data.data)
    return res.data;
  }

  //get products count
  getProductsCount = async (account_no: any,currency: any = "",filter: any = '',limitPerPage: any = 20,offset: any = 0) => {
    let orderByPosition = filter.indexOf("order by")
    if (orderByPosition >= 0) {
      filter = filter.substring(0, orderByPosition)
    }

    let properties = {
      "type": "bar",
      "xaxis": "''",
      "yaxis": "count(product_data.product_id)",
      "xaxis_alias": "product_type",
      "yaxis_alias": "total_products"
    }
    let pos = filter.indexOf("order by")
    if (pos >= 0) {
      filter = filter.substring(0, pos)
    }
    const bodyData = {
      "properties": properties,
      "filter": filter,
      "limit": "100",
      "offset": 0
    }
    //check if filter contains "order by" substring (then remove substring it from filter)
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "report"
      },
      method: "post",
      url: url + params,
      data: bodyData
    });
    res.data.data = this.modifyProductData(res.data.data)
    return res.data;

  }

  //product api
  getAllMerchantProducts = async (account_no: any,filter: any = '',currency: any = "",limitPerPage: any = 20,offset: any = 0,persona: any) => {
    const productProperties = [
      "product_description_id",
      "product_id",
      "product_type_id",
      "product_supplier_status_text",
      "product_category_id",
      "product_sub_type_id",
      "net_volume_unit",
      "is_marketplace",
      "product_lifecycle_status"
    ]
    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': persona === "nokia" ? 'nokia' : 'supplier'
      },
      method: "post",
      url: url + params,
      data: data
    });
    res.data.data = this.modifySupplierProductData(res.data.data)
    return res.data;
  }

  getSpecificProductData = async (account_no: any,currency: any = "",productIds: any) => {
    let properties_data = [
      'product_data.id',
      'product_data.is_agent_model',
      'product_data.product_type_id',
    ];
    // Ensure each id is wrapped in double quotes
    let quotedProductIds = productIds
      .split(',')
      .map((id: any) => id.trim().replace(/^['"]|['"]$/g, ''))
      .map((id: any) => `"${id}"`).join(',');
    let filter = `product_data.id IN (${quotedProductIds})`
    const bodyData = {
      "properties": properties_data,
      "filter": filter,
      "limit": "100",
      "offset": 0
    }
    //check if filter contains "order by" substring (then remove substring it from filter)
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = `?_format=json&account=${account_no}&currency=${currency}&specificProducts=true`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: url + params,
      data: bodyData
    });
    return res.data;

  }


  modifySupplierProductData = (data: any) => {
    const updatedProducts = data.map((item: any) => {
      const product_image = DATAMART_GLOBAL.blobProductPath + `${item.product_id}.png`;

      let updatedItem = {
        ...item,
        product_image,
      };


      return updatedItem;
    });

    return updatedProducts;
  }

  // //Get the dropdown list options
  // getNokiaProductsListData =  async(field: any)=>{
  //   const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;
  //   const params = `?properties=${field}&group=${field}&format=list`;
  //    const res = await axios({
  //     headers: {
  //       'x-user-id': this.userID,
  //     },
  //     method: "get",
  //     url: url + params
  //   });
  //   return res.data;
  // }


  getAllNokiaProducts = async (filter: any = '',currency: any = "",limitPerPage: any = 20,offset: any = 0,persona: any,operation: any = "read",query: any,sort: any) => {
    const productProperties = [
      "id",
      "product_description",
      "product_lifecycle_status",
      "product_family_id",
      "product_type_id",
      "product_sub_type_id",
      "commercial_model_id",
      "product_id",
      "product_source_id",
      "network_support_id",
      "c3_ready_for_offering",
      "c7_end_of_offering",
      "gic_l_code",
      "created_by",
      "createdAt",
      "updated_by",
      "updatedAt",
      "base_uom_id",
      "product_category_uuid",
      "is_agent_model",
      "is_marketplace",
      "dc_licence_id",
      "successor_replacement_product_id",
      "product_tool_tip_content_id",
      "additional_info_for_phase_out_product_id",
      "memory_required",
      "pod_required",
      "storage_required",
      "vcpu_required",
      "custom_description",
      "custom_tariff_code",
      "eccn_eu",
      "eccn_us",
      "country_of_origin",
      "time_commitment_based_discount_allowed_id",
      "pre_c3_development_ongoing",
      "c3_ready_for_offering",
      "c4_ready_for_ordering",
      "c5_released",
      "c6_ramp_down_started",
      "c7_end_of_offering",
      "c8_end_of_ordering",
      "c9_end_of_deliveries",
      "c10_end_of_maintenance_id",
      "supplier_id",
      "supplier_part_number_id",
      "supplier_lead_time_id",
      "is_kit",
      "marketplace_product_id",
      "fulfillment_mode",
      "serial_number_profile",
      "hws_portfolio_id",
      "standard_warranty_duration_months",
      "offered_extended_warranty_duration_months",
      "hw_replacement_sla_id",
      "related_entitlement_id",
      "related_entitlement_quantity",
      "successor_replacement_product_id",
      "memory_capacity",
      "pod_capacity",
      "storage_capacity",
      "vcpu_capacity",
      "identified_stock_type",
      "net_weight",
      "net_weight_unit",
      "gross_weight",
      "gross_weight_unit",
      "net_volume",
      "net_volume_unit",
      "gross_volume",
      "gross_volume_unit",
      "height",
      "height_unit",
      "kclength",
      "length_unit",
      "width",
      "width_unit",
      "dangerous_goods_classification",
      "battery_data_field",
      "packing_instruction",
      "section",
      "dg_clr",
      "purchasing_status_id",
      "purchasing_status_text",
      "dangerous_goods_un_number",
      "supplier_id",
    ];

    const filterQuery = filter ? filter.split("AND").map((item: any) => item.trim()) : [];
    let filterString = "";

    if (filterQuery.length > 0) {
      // Map each item to include the 'filters' prefix, then join them with '&'
      // Example: ["filters[A]", "filters[B]"] -> "filters[A]&filters[B]"
      filterString = filterQuery.map((item: any) => `filters${item}`).join('&');
      // Prepend with '&' for the first parameter, resulting in "&filters[A]&filters[B]"
      filterString = `&${filterString}`;
    }

    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;

    let params = query != "" ?
      `?properties=${productProperties}&limit=${limitPerPage}&offset=${offset}&query=${query}` :
      (filterString != "" || sort != "") ?
        `?properties=${productProperties}&limit=${limitPerPage}&offset=${offset}${filterString}&sort=${sort}` :
        `?properties=${productProperties}&limit=${limitPerPage}&offset=${offset}`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'x-factory': persona === "nokia" ? 'nokia' : 'supplier',
      },
      method: "get",
      url: url + params
    });
    //res.data.data = this.modifySupplierProductData(res.data.data)
    return res.data;
  }

  downloadNokiaProductsCsv = async (filters: any = {},persona: any = "nokia") => {
    const apiUrl = `${DATAMART_GLOBAL.baseUrl}/v3/product`;
    const params = new URLSearchParams();
    const requestPayload: Record<string, any> = (filters && typeof filters === 'object') ? { ...filters } : {};
    const downloadValue = String(requestPayload?.download ?? 'true');

    if (Object.prototype.hasOwnProperty.call(requestPayload, 'download')) {
      delete requestPayload.download;
    }

    params.set(
      'properties',
      '*'
    );
    params.set('export', 'csv');
    params.set('download', downloadValue);
    params.set('limit', '-1');

    const exactMatchFields = new Set([
      'product_family_id',
      'product_type_id',
      'product_category_uuid',
      'base_uom_id',
      'country_of_origin',
    ]);

    // Add all non-empty filters.
    // Use exact match for enum-like fields and LIKE for free-text fields.
    if (requestPayload && typeof requestPayload === 'object') {
      Object.entries(requestPayload).forEach(([field, value]) => {
        const normalizedValue = typeof value === 'string' ? value.trim() : String(value ?? '').trim();
        if (normalizedValue) {
          if (exactMatchFields.has(field)) {
            params.set(`filters[${field}]`, normalizedValue);
          } else {
            params.set(`filters[${field}][$like]`, `%${normalizedValue}%`);
          }
        }
      });
    }

    const response = await axios({
      headers: {
        'x-user-id': this.userID,
        'x-factory': persona === "nokia" ? 'nokia' : 'supplier',
        'operation': 'read',
      },
      method: 'get',
      url: `${apiUrl}?${params.toString()}`,
      responseType: 'blob',
      timeout: 0,
    });
    return response;
  }

  getNokiaProductsCount = async (filter: any = "") => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster
    const productProperties = [
      "id",
      "product_description",
      "product_lifecycle_status",
      "product_family_id",
      "product_type_id",
      "product_sub_type_id",
      "commercial_model_id",
      "product_id",
      "product_source_id",
      "network_support_id",
      "c3_ready_for_offering",
      "c7_end_of_offering"
    ];
    const filterQuery = filter ? filter.split("AND").map((item: any) => item.trim()) : [];
    let filterString = "";

    if (filterQuery.length > 0) {
      // Map each item to include the 'filters' prefix, then join them with '&'
      // Example: ["filters[A]", "filters[B]"] -> "filters[A]&filters[B]"
      filterString = filterQuery.map((item: any) => `filters${item}`).join('&');
      // Prepend with '&' for the first parameter, resulting in "&filters[A]&filters[B]"
      filterString = `&${filterString}`;
    }

    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;

    let params =
      filterString != "" ?
        //`?properties=COUNT(*):total_products&filters[product_type_id][$in]=Hardware,Other,Services,Software${filterString}`:
        `?properties=product_type_id,COUNT(*):total_products&group=product_type_id${filterString}` :
        `?properties=product_type_id,COUNT(*):total_products&filters[product_type_id][$in]=Hardware,Other,Services,Software&group=product_type_id`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'getCount': true
      },
      method: "get",
      url: apiUrl + "/product" + params
    });

    return res.data;
  }

  getProductMasterEnums = async () => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'getCount': true
      },
      method: "get",
      url: url + "?format=lookup&properties=product_type_id,purchasing_status,serial_number_profile,net_weight_unit,net_volume_unit,gross_weight_unit,gross_volume_unit,dangerous_goods_un_number,dangerous_goods_classification,base_uom,identified_stock_type,product_status,product_category_uuid,width_unit,height_unit,length_unit"
    });

    return res.data;
  }


  getMerchantAllProducts = async (account_no: any,filter: any = '',currency: any = "",limitPerPage: any = 20,offset: any = 0,persona: any,operation: any = "read") => {
    const productProperties = operation === 'read' ? [
      "product_description_id",
      "product_id",
      "product_type_id",
      "product_supplier_status_text",
      "product_category_id",
      "product_sub_type_id",
      "net_volume_unit",
      "is_marketplace",
      "product_lifecycle_status",
      "createdAt",
      "product_specifications",
      "image_base_url",
      "price_amount_eur",
      "price_amount_usd",
      "status",
      "supplier_text",

    ] : {
      "type": "bar",
      "xaxis": "product_lifecycle_status",
      "yaxis": "count(product_id)",
      "xaxis_alias": "product_lifecycle_status",
      "yaxis_alias": "total_products"
    }
    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": operation === 'read' ? limitPerPage : 100,
      "offset": operation === 'read' ? offset : 0
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': operation,
        'x-factory': persona === "nokia" ? 'nokia' : 'supplier'
      },
      method: "post",
      url: url + params,
      data: data
    });
    res.data.data = this.modifySupplierProductData(res.data.data)
    return res.data;
  }


  getAllMerchantOrders = async (filter: any = '',limitPerPage: any = 20,offset: any = 0) => {
    const productProperties = [
      "sales_order_id",
      "account_id",
      "accountnumber",
      "name",
      "market",
      "business_name",
      "sales_order_text",
      "status_header_id",
      "approval_status_id",
      "approval_status",
      "order_type",
      "so_createdAt",
      "posting_date",
      "invoiced_quantity",
      "invoiced_amount_transactional_currency",
      "address",
      "street",
      "city",
      "postal_code",
      "country_region",
      "country_id",
      "net_value_transactional_currency",
      // "agent_model_order_price",
      // "agent_model_requested_quantity"
    ]
    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.shadowOffer;
    const params = `?_format=json`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': "sales_order"
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifySupplierProductData(res.data.data)
    res.data.data = this.modifyOrderData(res.data.data)
    return res.data;
  }


  getAllMerchantOrdersForMerchantTab = async (filter: any = '',limitPerPage: any = 20,offset: any = 0,agentStatsFilter: any,agentStatsSort: any,selectedMerchant: any,persona: any) => {
    const productProperties = [
      "sales_order_id",
      "account_id",
      "accountnumber",
      "name",
      "market",
      "business_name",
      "sales_order_text",
      "status_header_id",
      "approval_status_id",
      "approval_status",
      "order_type",
      "so_createdAt",
      "posting_date",
      "requested_quantity",
      "net_value_transactional_currency",
      "account_id",
      // "agent_model_order_price",
      // "agent_model_requested_quantity",
      "address",
      "country_region",
      "city",
      "street",
      "postal_code",
      "state_id",
      "state"
    ]
    const data = {
      "properties": productProperties,
      "filter": filter,
      "agentStatsFilter": agentStatsFilter,
      "agentStatsSort": agentStatsSort,
      "limit": limitPerPage,
      "offset": offset
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.shadowOffer;
    const params = `?_format=json`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': "sales_order",
        'x-supplier-id': persona === "nokia" ? selectedMerchant : ""
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifySupplierProductData(res.data.data)
    res.data.data = this.modifyOrderData(res.data.data)
    return res.data;
  }

  modifyOrderData = (data: any) => {
    const updatedProducts = data.map((item: any) => {
      let postdate = item.posting_date.split(" ")
      const postingDateFormate = postdate[0]
      let updatedItem = {
        ...item,
        postingDateFormate
      };


      return updatedItem;
    });
    return updatedProducts;
  }



  getAllMerchantOrdersForMerchantReport = async (filter: any = '',type: any,limitPerPage: any = 100,offset: any = 0) => {
    const productProperties = type === "Finish" ? {
      "type": "bar",
      "xaxis": "delivery_status_item",
      "yaxis": "count(offer_sales_order_items.sales_order_id)",
      "xaxis_alias": "delivery_status_item",
      "yaxis_alias": "total_sales_order"
    } :
      {
        "type": "bar",
        "xaxis": "status_header",
        "yaxis": "count(offer_sales_order.sales_order_id)",
        "xaxis_alias": "status_header",
        "yaxis_alias": "total_sales_order"
      }

    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset
    }
    const url = type === "New" ? DATAMART_GLOBAL.baseUrl + "/v2" + DATAMART_GLOBAL.endPoints.shadowOffer : DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.offerReport;
    const params = `?_format=json`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "report",
        'x-factory': "sales_order"
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifySupplierProductData(res.data.data)
    return res.data.data;
  }

  getAllMerchantOrderItems = async (filter: any = '',limitPerPage: any = 20,offset: any = 0,sales_order_ids: any = false) => {
    const productProperties = sales_order_ids ? ["sales_order_id", "net_value_transactional_currency", "requested_quantity", "delivery_status_item", "net_value_without_freight_transactional_currency"] : [
      "sales_order_id",
      "sales_order_item_id",
      "external_item_reference_id",
      "delivery_status_item",
      "invoicing_status_item",
      "fulfillment",
      "customer_information_item_id",
      "internal_comment_item_id",
      "reason_for_rejection_item",
      "item_processing_type",
      "item_type",
      "parent_product",
      "product_text",
      "product_id",
      "requested_date",
      "last_confirmed_date",
      "requested_quantity",
      "requested_quantity_sales_unit_of_measure",
      "confirmed_quantity",
      "confirmed_quantity_sales_unit_of_measure",
      "fulfilled_quantity",
      "fulfilled_quantity_sales_unit_of_measure",
      "confirmed_fulfilled_quantity",
      "invoiced_quantity",
      "invoiced_quantity_sales_unit_of_measure",
      "net_value_transactional_currency",
      "invoiced_amount_transactional_currency",
      "invoiced_amount",
      "createdAt",
      "updatedAt",
      "account_id",
      "supplier_id",
      "is_agent_model",
      "net_value_without_freight_transactional_currency"
    ]
    const data = {
      "properties": productProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset

    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.orderitems;
    const params = `?_format=json`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': "sales_order"
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifySupplierProductData(res.data.data)
    return res.data;
  }

  modifyProductData = (data: any) => {
    const updatedProducts = data.map((item: any) => {
      const product_quantity = 1;
      const product_total_cost = (product_quantity * item.price_amount).toFixed(2);
      const product_image = DATAMART_GLOBAL.blobProductPath + `${item.id}.png`;
      const isDeliverable = true
      let updatedItem = {
        ...item,
        product_quantity,
        product_total_cost,
        product_image,
        isDeliverable
      };

      //checking for subscription products , if subscription then adding duration by default as 1
      if (
        (item.product_type_id === 'Software' && item.product_sub_type_id === 'Applications') ||
        (item.product_type_id === 'Services' && item.product_sub_type_id === 'Subscription')
      ) {
        updatedItem.duration = 12;
      }

      return updatedItem;
    });

    return updatedProducts;
  }


  getDashboardQuotationAPI = async (filter: any = '',limit: any = 100,offset: any = 0) => {
    const offerProperties = [
      "offer.offer_id",
      "offer.offer_created_date",
      "offer.summary_total_list_price",
      "offer_items.product_id",
      "offer_items.supplier_id",
      "offer.status",
      "product_sub_type",
      "product_type",
      "title",
      "product_id",
      "price",
      "quantity",
      "offer.source",
      "offer.shipping_country",
      "is_agent_model"
    ]
    const data = {
      "properties": offerProperties,
      "filter": filter,
      "limit": limit,
      "offset": offset
    }
    //const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;

    const params = '?_format=json&';
    //const url = 'http://localhost:3000/offer/getAllOffers';
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.orderitems;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': 'offer'
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifyProductData(res.data.data)
    return res.data;
  }

  getDashboardQuotationOfferAPI = async (filter: any = '',limit: any = 100,offset: any = 0) => {
    const offerProperties = [
      "offer_header_data.offer_id",
      "offer_header_data.field_ofr_order_currency",
      "offer_header_data.field_ofr_order_market",
      "offer_header_data.field_ofr_order_approved_date",
      "offer_header_data.field_ofr_order_shipping_country"
    ]
    const data = {
      "properties": offerProperties,
      "filter": filter,
      "limit": 10,
      "offset": offset
    }
    //const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;

    const params = '?_format=json&';
    //const url = 'http://localhost:3000/offer/getAllOffers';
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getAllOffers;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': 'offer'
      },
      method: "post",
      url: url + params,
      data: data
    });
    // res.data.data = this.modifyProductData(res.data.data)
    return res.data;
  }


  //offer api from datamart



  saveOffer = async ({ data, source = 'cui' }: any) => {
    const params = `?username=${this.email}&source=${source}`;
    const res = await axios({
      headers: {
        // "Content-Type": "multipart/form-data",
        'x-user-id': this.userID,
      },
      method: "post",
      //url: 'http://localhost:3000/offer' + params,
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.shadowOffer + params,
      data: data,
    });
    return res.data;
  };



  getAllUsers = async (filter: any,limitPerPage: any,offset: any,userType: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.bulkUsers;
    //const url = 'http://localhost:3000/user/all'
    // const params = "?_format=json&method = fetch"
    const userProperties = [
      "users.id",
      "users.email",
      "users.active",
      "users.name",
      "user_roles.role",
      "users.type",
      "users.last_login_time"
    ]
    const data = {
      "properties": userProperties,
      "filter": filter,
      "limit": limitPerPage,
      "offset": offset
    }
    const res = await axios({
      headers: {
        // "Content-Type": "multipart/form-data",
        'x-user-id': this.userID,
        'x-factory': userType
      },
      method: "post",
      url: url,
      data: data
    });

    return res.data;
  }



  //add user
  addEditUser = async (data: any,operation: any,x_factory: any,x_source: any = "") => {
    const params = `?operation=${operation}`
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.user + params
    //const url = `http://localhost:3000/user?operation=${operation}`
    let apiHeaders: Record<string, string | undefined> = {
      'x-user-id': this.userID,
      'x-factory': x_factory,
    }
    //This header will be only for esign user addition
    if (x_source !== "") {
      apiHeaders['x-source'] = x_source;
    }
    const res = await axios({
      headers: apiHeaders,
      method: "post",
      url: url,
      data: data,
    });
    return res.data;
  }


  disableUser = async (data: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.user
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'disable-user-id': data,
        'x-factory': "user"
      },
      method: "delete",
      url: url,
    });
    return res.data;
  }



  uploadPOMarketplace = async (formData: any,source: any = 'cui') => {
    const res = await axios({
      headers: {
        //  'Content-Type': 'multipart/form-data',
        'x-user-id': this.userID,
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.uploadPO,
      //url: 'http://localhost:3000/offer/uploadPO',
      data: formData,
    })
    return res.data;
  }

  //get countries from datamart
  getAllCountries = async (filterCondition: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.countryApi
    //const url = "http://localhost:3000/country"
    const data = {
      "properties": [
        "country.iso_2",
        "country.name",
        "country.is_merchant_products_allowed",
        "country.is_allowed_for_marketplace",
        "country.short_region_code"
      ],
      "filter": filterCondition,
      "limit": 300,
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: url,
      data: data
    });
    return res.data;
  }


  //save cart items to datamart
  saveCartDetailsAPI = async (data: any,queryParam: any) => {

    const params = `?${queryParam}`
    //const apiUrl = 'http://localhost:3000/offer/' + params
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.shadowOffer + params
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: apiUrl,
      data: data,
    });
    return res.data;
  }


  //api to get product types
  getProductTypes = async (account_no: any,currency: any = "",filter: any) => {
    const productTypeProperties = [
      "distinct product_data.product_id"
    ]
    const data = {
      "properties": productTypeProperties,
      "filter": filter,
      "limit": 100,
      "offset": 0
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        "operation": "read"
      },
      method: "post",
      url: url + params,
      data: data
    });
    return res.data;

  }

  //api to get product subtypes
  getProductSubTypes = async (account_no: any,currency: any = "",filter: any) => {
    const productSubTypeProperties = [
      "distinct product_data.product_sub_type_id"
    ]
    const data = {
      "properties": productSubTypeProperties,
      "filter": filter,
      "limit": 100,
      "offset": 0
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        "operation": "read"
      },
      method: "post",
      url: url + params,
      data: data
    });
    return res.data;

  }

  //api to get product sub categories
  getProductSubCategoriesList = async (account_no: any,currency: any = "",filter: any,crosserFilterData: any = '') => {
    const productSubCategoryProperties = [
      "distinct product_data.product_sub_category"
    ];

    const data = {
      "properties": productSubCategoryProperties,
      "filter": filter,
      "limit": 100,
      "offset": 0,
      // Product bundle related additional flags
      "includeCompactKits": true,
      "shippingCountry": store.getState()?.marketplace?.filters?.selection?.shippingCountry || null,
      "responseData": "filters",
      "crosserFilter": crosserFilterData ? crosserFilterData : filter, // Use the same filter as both are baseFilter, ie; marketplaceSelector.productQueryFilter
    }
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const params = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        "operation": "read"
      },
      method: "post",
      url: url + params,
      data: data
    });
    return res.data;

  }

  getTermsConditions = async (ids: any,filter: any) => {
    const bodyParams = {
      "properties": [
        "merchant_terms_and_conditions.terms_and_conditions",
        "merchant_terms_and_conditions.merchant_id",
        "merchant_terms_and_conditions.version_id"

      ],
      "filter": filter,
      "one_star_id": ids,
      "limit": 1,
      "offset": 0
    }

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'requested_info': "supplier"
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getAccountData,
      data: bodyParams
    });

    return res.data;
  }


  getUserRoles = async (queryFilter: any) => {
    const bodyParams = {
      "properties": [
        "id",
        "name",
        "data_objects"
      ],
      "filter": queryFilter,
      "limit": 100,
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'Content-Type': 'application/json'
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getUserRoles,
      //url: `http://localhost:3000/roles/all`,
      data: bodyParams
    });
    return res.data;
  }

  saveUserRoles = async (data: any,operation: any) => {
    const params = `?operation=${operation}`
    //const apiUrl = 'http://localhost:3000/roles' + params
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.saveUserRoles + params
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: apiUrl,
      data: data,
    });
    return res.data;
  }

  //get hierachy data
  getHierarchyData = async (filter: any,x_factory: any) => {
    const bodyParams = {
      "properties": [
        "distinct id",
        "level"
      ],
      "filter": filter,
      "limit": 1000,
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': x_factory
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.hierachyLevels,
      // url: `http://localhost:3000/hierarchy`,
      data: bodyParams
    });
    return res.data;
  }

  getHierarchyDataUniq = async (filter: any,x_factory: any) => {
    const bodyParams = {
      "properties": [
        "distinct level4_id, level5_id, level6_id, level, id",
      ],
      "filter": filter,
      "limit": 1000,
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'x-factory': x_factory
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.hierachyLevels,
      // url: `http://localhost:3000/hierarchy`,
      data: bodyParams
    });
    return res.data;
  }

  getAccountsForInternalExternal = async (filter: any,limit: any = 10,offset: any = 0,requestedInfo: any = "sell_to_party",oneStarId: any = []) => {
    const propertiesList = requestedInfo === "sell_to_party" ? ["business_name", "name", "account_id", "parent_account_number", "customer_account_number", "market", "l4_id", "l5_id", "l6_id", "l7_id", "customer_compliance", "accountnumber", "account_domains"] : ["business_name", "name", "parent_account_number", "customer_account_number", "market", "l4_id", "l5_id", "l6_id", "l7_id", "customer_compliance", "accountnumber", "account_domains"]
    const bodyParams = {
      "properties": propertiesList,
      "filter": filter,
      "one_star_id": oneStarId,
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'requested_info': requestedInfo
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.allAccounts,
      // url: `http://localhost:3000/v1/account`,
      // url: `http://localhost:3000/account_list`,
      data: bodyParams
    });
    return res.data;
  }



  //get account details for merchant/supplier
  getAccountDetailsMerchant = async (filter: any,limit: any = 10,offset: any = 0,one_star_id: any = [],requested_info: any = "supplier") => {
    const bodyParams = {
      "properties": [
        "account_id",
        "name",
        "legalform_id",
        "legal_form",
        "status_id",
        "status",
        "incoterms_id",
        "incoterms",
        "payment_terms_id",
        "payment_terms",
        "purchase_order_currency",
        "address_info"
      ],
      "filter": filter,
      "supplier_id": one_star_id,
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'requested_info': requested_info
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.allAccounts,
      // url: `http://localhost:3000/v1/account`,
      data: bodyParams
    });
    return res.data;
  }


  //get azure applications for machines and whitelisted clients
  getAzureApplications = async (searchText: any) => {
    const params = `?searchText=${searchText}`
    const res = await axios({
      headers: {
        'x-user-id': this.userID,

      },
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.applicationList + params,
      //url: `http://localhost:3000/application` + params,
    });
    return res.data;

  }

  getSegmentForm = async (solution: any) => {
    const params = `?_format=json&username=${this.email}`;
    const url = OOT_CONFIGURATOR.baseUrl + OOT_CONFIGURATOR.endPoints.configurator
    const res = await axios({
      method: "get",
      url: url + '/segment/' + solution + params,
    });
    return res.data;
  };

  segmentFormSubmission = async (method: any, solutionName: any, cartDataList: any, sid: string, eot_params: string, undo: boolean) => {
    let params = `?_format=json&username=${this.email}&${eot_params}`;
    if (sid !== "") {
      params = `?_format=json&username=${this.email}&sid=${sid}&${eot_params}`;
    }
    const url = OOT_CONFIGURATOR.baseUrl + OOT_CONFIGURATOR.endPoints.configurator
    // if undo is true then validate is false
    params = undo ? params + '&validate=false' : params + '&validate=true';
    const res = await axios({
      method: method,
      url: url + '/segment/' + solutionName + params,
      data: cartDataList
    });
    return res.data
  }

  configuratorDataCallback = async (method: any,endPoint: any,args: any, post_data?: any) => {
    let params = `?_format=json&username=${this.email}`;
    endPoint = (endPoint).split('/api/configurator')[1];
    let joinargs = args.length > 0 ? '&' + args : '';
    let requestpayload = {};
    const url = OOT_CONFIGURATOR.baseUrl + OOT_CONFIGURATOR.endPoints.configurator
    if (post_data) {
      const res = await axios({
        method: method,
        url: url + endPoint + params + joinargs,
        data: post_data
      });
      return res.data;
    } else {
      requestpayload = {
        method: method,
        url: url + endPoint + params + joinargs
      };
      const res = await axios(requestpayload);
      return res.data;
    }
    // const res = await axios(requestpayload);
    // return res.data;
  }

  getScrmidValid = async (filter: any,scrm_id: any) => {
    const bodyParams = {
      "properties": [
        "opportunity_id",
        "stagename",
        "account_legal_entity_number",
        "acc_no__c",
        "market",
        "market_segment",
        "l4_id",
        "l5_id",
        "l6_id",
        "l7_id",
        "parent_account_number",
        "customer_account_number",
        "one_customer_name",
        "customer_account_name",
        "customer_compliance",
        "end_customer_le__r_accountnumber",
        "end_customer_legal_entity_number"
      ],
      "filter": filter,
      "limit": 10,
      "offset": 0,
      "opportunity_id": [scrm_id]
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.opportunity,
      // url: `http://localhost:3000/hierarchy`,
      data: bodyParams
    });
    return res.data;
  }


  getRadioNetworkPlan = async (currentPage: any,limitPerpage: any) => {
    const bodyParams = {
      "properties": [
        "opportunity_id",
        "stagename",
        "account_legal_entity_number",
        "acc_no__c",
        "market",
        "market_segment",
        "l4_id",
        "l5_id",
        "l6_id",
        "l7_id",
        "parent_account_number",
        "customer_account_number",
        "one_customer_name",
        "customer_account_name",
        "customer_compliance",
        "transaction_id",
        "plan_info"
      ],
      "filter": "",
      "opportunity_id": [],
      "limit": limitPerpage,
      "offset": currentPage
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.planUpdate,
      // url: `http://localhost:3000/hierarchy`,
      data: bodyParams
    });
    return res.data;
  }


  planUpdateCIQ = async (data: any,operation: any) => {
    //const apiUrl = 'http://localhost:3000/roles' + params
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.planUpdate
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': operation
      },
      method: "post",
      url: apiUrl,
      data: data,
    });
    return res.data;
  }

  getAgreementDetails = async (one_star_number: any,limit: any = 10,offset: any = 0) => {
    let params = `?one_star_number=${one_star_number}`
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.agreementData
    const bodyData = {
      "orderBy": "field_part_agre_term_agreement_start_date desc",
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params,
      data: bodyData,
    });

    return res.data;
  }

  getCertificationDetails = async (email: any,orderBy: any = "",limit: any = 10,offset: any = 0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.certificationData
    const bodyData = {
      "email": email,
      "orderBy": orderBy,
      "limit": 10,
      "offset": 0
    }
    const res = await axios({
      headers: {
        // 'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: apiUrl,
      data: bodyData,
    });

    return res.data;

  }
  getDomainNameList = async (filter: any,limit: any,offset: any) => {
    //const apiUrl = 'http://localhost:3000/roles' + params
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.allAccounts
    const params = `?_format=json`;
    const bodyData = {
      "properties": [
        "distinct(record_type)"
      ],
      "filter": filter,
      "supplier_id": [],
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'requested_info': 'sell_to_party',
        'operation': 'read'
      },
      method: "post",
      url: apiUrl + params,
      data: bodyData,
    });
    return res.data;
  }

  //get cart information for user
  getUserCartInfo = async () => {
    //const apiUrl = 'http://localhost:3000/roles' + params
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.cartData
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': 'read'
      },
      method: "post",
      url: apiUrl,
      //  data: bodyData,
    });
    return res.data;
  }

  //network master related APIs
  getNetworkMasterList = async (limit: any = 10,offset: any = 0,filter: any = "",sortBy: any = "",sendAllowedValues: any, onlyNetworkId?: any) => {
    // let params = `?one_star_number=${one_star_number}`
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    //const apiUrl = "http://localhost:4000/v2/network"
    const properties = `network_id,offer_id,accountnumber,network_name,slice,slice_gr,slice_spare,core_offer_id,next_renewal_date,technical_status,commercial_status,network_classification,created,network_location,network_metadata_market,account_name,network_sales_owners,inside_sales_owners,end_customer_account_name,sw_sla,network_end_date,dc_no,old_scrm_id,new_scrm_id,tsrs_ticket_id,next_renewal_offer_date,no_auto_renewal_comments,sites,active_use_case,non_nokia_ue,non_nokia_app,segment,lifecycle,nokia_app,nokia_ue,preferred_communication_channel,renewal_duration,invoicing_frequency,offer_id,network_details,offers,commercial_model,auto_renewal,scrm_type,scrm_instructions,multinetwork_renewal,sales_channel,lead_product,organization_type,end_customer_accountnumber,disconnect_reason,disconnect_reason_comment,account_uuid,scrm_validated,renewal_term,invoice_frequency,network_last_online,associated_offers,hardware_refresh,commercial_status`;
    // const params = `?properties=${properties}&limit=${limit}&offset=${offset}`;
    let params = sendAllowedValues == true ? `?properties=${properties}&field_allowed_values=true`
      : `?properties=${properties}`;

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    params += `&order_by=${sortBy}&limit=${limit}&offset=${offset}`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }


  //Get ntk column customization
  getColumnCustomization = async (filter: string = "") => {
    //https://ece-data-platform-dev.azurewebsites.net/v2/table-preferences?properties=ucp_id,page_or_component,preferences&limit=20&offset=0&filter=page_or_component="network2"
    //const apiUrl = "http://localhost:4000/v2/table-preferences"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.columnCustomize
    const properties = `ucp_id,page_or_component,preferences&limit=20&offset=0`;
    let params = `?properties=${properties}`;

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  //create column customization - POST
  createColumnCustomization = async (data: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.columnCustomize;
    data.uid = this.userID;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: apiUrl,
      data: data
    });
    return res.data;
  }

  //update column customization - PUT
  updateColumnCustomization = async (data: any,ucpId: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.columnCustomize + "/" + ucpId;
    data.uid = this.userID;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "put",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  //create product master data - POST
  createProductMasterData = async (data: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;
    //data.uid = this.userID;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "POST",
      url: apiUrl,
      data: data
    });
    return res.data;
  }

  //update product master data - PATCH
  updateProductMasterData = async (data: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;
    //data.uid = this.userID;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "PUT",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  //get slices based on network id
  getNetworkSlicesBasedOnNetworkId = async (network_id: any,limit: any = 20,offset: any = 0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkSliceList
    const properties = `network_id,slice_id,slice_type,nhg_id,status`;
    let filter = `network_id:${network_id};status:active`;
    const params = `?properties=${properties}&filter=${filter}&limit=${limit}&offset=${offset}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }


  //get contacts based on network id
  getNetworkContactsBasedOnNetworkId = async (network_id: any = "",filterValue: any = "",limit: any = 20,offset: any = 0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkContactList
    const properties = `network_id,contact_email,contact_type,override`;
    let filter = `network_id:${network_id};${filterValue}`;
    const params = `?properties=${properties}&filter=${filter}&limit=${limit}&offset=${offset}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  getNetworkCount = async (filter: any = "") => {
    //const apiUrl = "http://localhost:4000/v2/network"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const properties = `network_id,network_name,account_name,end_customer_account_name,slice,network_metadata_market,network_sales_owners,lifecycle,core_offer_id`;
    let params = `?properties=${properties}&limit=1&offset=0`;

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'getCount': true
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  //save network followup
  saveNetworkFollowup = async (data: any) => {
    //const apiUrl = "http://localhost:4000/v2/network"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "put",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  createNetworkFollowup = async (data: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  getNetworkFollowupDetails = async (network_id: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const properties = `old_scrm_id,new_scrm_id,tsrs_ticket_id,next_renewal_offer_date,no_auto_renewal_comments,sites,active_use_case,non_nokia_ue,non_nokia_app,segment,lifecycle,nokia_app,nokia_ue,preferred_communication_channel,renewal_duration,invoicing_frequency,auto_renewal`;
    let filter = `network_id:${network_id}`;
    const params = `?properties=${properties}&filter=${filter}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  getNetworkComments = async (network_id: any,limit: any = 50,offset: any = 0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkComments
    const properties = `network_id,cid,comment,uid,user_name,created_at,updated_at`;
    let filter = `network_id:${network_id}`;
    const params = `?properties=${properties}&filter=${filter}&limit=${limit}&offset=${offset}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  getNetworksReportCount = async (filter: any = "") => {
    //const apiUrl = "http://localhost:4000/v2/network"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const bodyData = {
      "properties": {
        "type": "bar",
        "xaxis": "technical_status",
        "yaxis": "count(distinct network_master.network_id)",
        "xaxis_alias": "technical_status",
        "yaxis_alias": "total_networks"
      },
      "filter": filter,
      "limit": "100",
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "report"
      },
      method: "post",
      url: apiUrl,
      data: bodyData

    });

    return res.data;
  }

  getNetworksExportAll = async () => {
    // const apiUrl = "http://localhost:4000/v2/network"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "export-all"
      },
      method: "get",
      url: apiUrl,
      responseType: 'blob' // Important for file downloads
    });

    return res; // Return the full response object for file handling
  }

  getNetworksExportFile = async (filterData: any = [],sortData: any = []) => {
    // const apiUrl = "http://localhost:4000/v2/network/export"
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkExport

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "customized"
      },
      method: "post",
      url: apiUrl,
      responseType: 'blob', // Important for file downloads
      ...((filterData && filterData.length > 0) || (sortData && sortData.length > 0)) && {
        data: {
          ...(filterData && filterData.length > 0 && { filter: filterData }),
          ...(sortData && sortData.length > 0 && { sort: sortData })
        }
      }
    });

    return res; // Return the full response object for file handling
  }


  addEditNetworkComments = async (data: any,operation: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "put",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  offerValidateCheck = async (filter: any,type: any = "") => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.offerValidate
    const params = `?_format=json`;
    const bodyData = {
      "properties": type === "CIQ" ? ["offer_id", "sell_to_party_accountnumber", "end_customer_accountnumber", "offer_status", "opportunity_id", "status", "co_owners", "owner_email", "case_name"] : [
        "offer_id",
        "name",
        "sell_to_party_accountnumber",
        "end_customer_accountnumber",
        "sell_to_party_name",
        "endcustomer_name",
        "network_location",
        "market",
        "sales_channel",
        "createdAt",
        "commercial_model",
        "lead_product",
        "type",
        "status",
        "bulk_order",
        "no_of_networks",
        "network_details",
        "renewal_duration",
        "invoicing_frequency"
      ],
      "filter": filter,
      "limit": "",
      "offset": ""
    }
    const res = await axios({
      headers: {
        'operation': 'read'
      },
      method: "post",
      url: apiUrl + params,
      data: bodyData,
    });
    return res.data;
  }


  productEdit = async (data: any,operation: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productDetailsEdit
    const params = `?operation=${operation}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: apiUrl + params,
      data: data
    });

    return res.data;
  }


  checkCiqCurrentStepData = async (data: any,type: any,perpreCiqInformationSelector: any) => {
    //http://localhost:8080/api/subscription-update?_format=json&username={{email}}
    let mail = "sudipta.das@nokia.com"
    // const params = `?email=${this.email}&username=${this.email}`;
    const params = perpreCiqInformationSelector.internalShare ? `?email=${this.email}&username=${this.email}` : `?email=${perpreCiqInformationSelector.externalUser.email}&username=${perpreCiqInformationSelector.externalUser.email}&user_id=${perpreCiqInformationSelector.externalUser.user_id}&ciq_user_type=external`;
    let Url = type === "validate" ? OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.CheckValidateCiq : type === "submit" ? OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.submitCiq : OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.getgenerateCiq
    const res = await axios({
      method: "post",
      url: Url + params,
      data: data,
    });
    return res.data;
  };


  checkCiqDataCallback = async (data: any,callbackUrl: any = "",type: any,perpreCiqInformationSelector: any) => {
    //http://localhost:8080/api/subscription-update?_format=json&username={{email}}
    let mail = "sudipta.das@nokia.com"
    // const params = `?email=${this.email}&username=${this.email}`;
    const params = perpreCiqInformationSelector.internalShare ? `?email=${this.email}&username=${this.email}` : `?email=${perpreCiqInformationSelector.externalUser.email}&username=${perpreCiqInformationSelector.externalUser.email}&user_id=${perpreCiqInformationSelector.externalUser.user_id}&ciq_user_type=external`;
    let Url = OOT_GLOBAL.proxyUrl + callbackUrl
    const res = await axios({
      method: type,
      url: Url + params,
      data: data,
    });
    return res.data;
  };





  checkCiqrrkDataCallback = async (callbackUrl: any = "",type: any,perpreCiqInformationSelector: any) => {
    //http://localhost:8080/api/subscription-update?_format=json&username={{email}}
    let Url = OOT_GLOBAL.proxyUrl + callbackUrl
    // const params = `?email=${this.email}&username=${this.email}`;
    const params = perpreCiqInformationSelector.internalShare ? `?email=${this.email}&username=${this.email}` : `?email=${perpreCiqInformationSelector.externalUser.mail}&username=${perpreCiqInformationSelector.externalUser.email}&user_id=${perpreCiqInformationSelector.externalUser.user_id}&ciq_user_type=external`;
    const res = await axios({
      method: type,
      url: Url + params
    });
    return res.data;
  };


  productRevision = async (data: any,operation: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productRevision
    // const params = `?operation=${operation}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': operation
      },
      method: "post",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  productRevisionDetails = async (filter: any,limit: any = 10,offset: any = 0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productRevision
    // const params = `?operation=${operation}`;
    const payload = {
      "properties": [
        "product_id",
        "revision_id",
        "product_details_status",
        "product_specifications",
        "image_base_url",
        "revision_updatedAt",
        "product_specifications_revision",
        "image_base_url_revision",
        "revision_createdAt",
        "revision_created_by",
        "reason_for_rejection",
        "approved_by",
        "approvedAt",
        "details_updated_by",
        "uploaded_images",
        "deleted_images",
        "thumbnail_image"
      ],
      "filter": filter,
      "order_by": "revision_updatedAt desc",
      "limit": 100,
      "offset": 0
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: apiUrl,
      data: payload
    });
    return res.data;
  }

  merchantProductWorkflowAPI = async (data: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.merchantProductWorkflow
    // const url = 'http://localhost:4000/workflow/merchant-product-workflow'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: url,
      data: data
    });
    return res.data;
  }

  productImagesUpload = async (formData: any,product_id: any,type: any) => {
    const url = DATAMART_GLOBAL.baseUrl + `/product/${product_id}/upload`
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'flag': type
      },
      method: "post",
      url: url,
      data: formData
    });
    return res.data;
  }

  productImageDelete = async (product_id: any,file_name: any) => {
    const url = DATAMART_GLOBAL.baseUrl + `/product/${product_id}/image`
    //const url = 'http://localhost:3000/user'
    let payload = {
      "file_name": file_name
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "delete",
      url: url,
      data: payload
    });
    return res.data;
  }

  triggerProductImageApi = async (imageFileName: string) => {
    const fileNameParts = String(imageFileName || '').split('_');
    const urlFileName = (fileNameParts[0] || imageFileName).replace(/\.[^./\\]+$/, '');
    const url = DATAMART_GLOBAL.baseUrl + `/product/${encodeURIComponent(urlFileName)}/image`;
    const payload = {
      file_name: imageFileName,
    };
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: 'delete',
      url,
      data: payload,
    });
    return res.data;
  }


  cancellationSubscriptionNew = async (data: any) => {
    //http://localhost:8080/api/subscription-cancellation?_format=json&username={{email}}
    const res = await axios({
      method: "post",
      url:
        DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.cancellationSubscription,
      data: data,
    });
    return res.data;
  };



  updateSubscriptionNew = async (data: any) => {
    //http://localhost:8080/api/subscription-update?_format=json&username={{email}}
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.updateSubscription,
      data: data,
    });
    return res.data;
  };


  getStockInventory = async (filter: any,account_no: any,limit: any = 10,offset: any = 0,sortbyConditionsNew: any,params: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.StockInventory + params
    const payload = {
      "properties": [
        "product_id",
        "account_id",
        "ms_material_id",
        "ms_material_id_text",
        "open_quantity",
        "close_quantity",
        "inbound_quantity",
        "outbound_quantity"
      ],
      "filter": filter,
      "order_by": sortbyConditionsNew,
      "limit": limit,
      "offset": offset
    }
    const res = await axios({

      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: apiUrl,
      data: payload
    });
    return res.data;
  }

  getStockInventoryIncomingStocks = async (filter: any,account_no: any,limit: any = 10,offset: any = 0,sortbyConditionsNew: any,params: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.incomingStockInventory + params
    const payload = {
      "properties": [
        "product_id",
        "product_text",
        "delivered_quantity",
        "delivery_start_date_id",
        "inbound_delivery_id_id",
        "serial_id_id"
        // "outb_delivered_quantity",
        // "outb_delivery_date_id",
        // "outb_shipment_date_id",
        // "outb_requested_date_id"
      ],
      "filter": filter,
      "order_by": sortbyConditionsNew,
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: apiUrl,
      data: payload
    });
    return res.data;
  }


  getStockInventoryOutgoingStocks = async (filter: any,account_no: any,limit: any = 10,offset: any = 0,sortbyConditionsNew: any,params: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.outgoingStockInventory + params
    const payload = {
      "properties": [
        "account_text",
        "product_id",
        "outbound_delivery_id_id",
        "product_text",
        "delivered_quantity",
        // "delivery_date_id",
        "offer_id_id",
        "sales_order_id_id",
        "account_text",
        "shipment_date_id"
      ],
      "filter": filter,
      "order_by": sortbyConditionsNew,
      "limit": limit,
      "offset": offset
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: apiUrl,
      data: payload
    });
    return res.data;
  }

  //service days APIS
  getServiceDaysList = async (filter: any,limit: any = 20,offset: any = 0,sortbyConditionsNew: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.serviceDays
    const properties = `nop_id,network_id,slice_id,offer_id,so_id,product_id,initial_qty,remaining_qty`;
    let params = `?properties=${properties}&limit=${limit}&offset=${offset}`;

    if (filter && filter.trim() !== "") {
      if (sortbyConditionsNew.length != 0) {
        params += `&filter=${filter}&order_by=${sortbyConditionsNew}`;
      }
      else {
        params += `&filter=${filter}`;
      }
    }

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  updateServiceDays = async (data: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.serviceDays
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "put",
      url: apiUrl,
      data: data
    });

    return res.data;
  }

  //save bookmarked products to datamart
  ciqImagesUpload = async (formData: any,params: any) => {
    const url = DATAMART_GLOBAL.baseUrl + `/file_upload/` + params
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: url,
      data: formData
    });
    return res.data;
  }
  ciqImagesDownload = async (params: any) => {
    const url = DATAMART_GLOBAL.baseUrl + `/file_download/` + params
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: url
    });
    return res.data;
  }

  ciqImagesDelete = async (params: any) => {
    const url = DATAMART_GLOBAL.baseUrl + `/file_delete/` + params
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "delete",
      url: url
    });
    return res.data;
  }


  //save bookmarked products to datamart
  productBulkUpload = async (formData: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.bulkUpload
    //const url = 'http://localhost:3000/user'
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "post",
      url: url,
      data: formData
    });
    return res.data;
  }


  initiateHandover = async (data: any) => {
    //  const url = 'http://localhost:4000/workflow/ms-network-planner'
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.intitateHandover,
      data: data,
    });
    return res.data;
  };

  initiateD2C = async (data: any) => {
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.initiateD2C,
      data: data,
    });
    return res.data;
  };


  checkOfferSliceIdTask = async (filter: any,limit: any,offset: any) => {
    const properties = `dl_id,offer_id,slice_id,handover_task_id`
    // const properties = `id,offer_id,slice_id,handover_task_id`
    let params = `?properties=${properties}`
    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }
    params += `&limit=${limit}&offset=${offset}`;
    const res = await axios({
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.sliceIdTask + params,
    });
    return res.data;
  };

  ciqSharecall = async (data: any,status: any) => {
    // const url = 'http://localhost:4000/workflow/ms-network-planner'
    const res = await axios({
      headers: {
        'operation': status,
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.sharelink,
      data: data,
    });
    return res.data;
  };

  getShareDetails = async (filter: any) => {
    const properties = `id, consumer, url, token, otp, shared_status, token_expiry, type, otp_used, last_accessed`
    let params = `?properties=${properties}`
    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }
    const res = await axios({
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.sharelink + params,
    });
    return res.data;
  }

  getShareAccessDetails = async (data: any,status: any) => {
    // const url = 'http://localhost:4000/workflow/ms-network-planner'
    const res = await axios({
      headers: {
        'operation': status,
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.sharelink,
      data: data,
    });
    return res.data;
  };

  //Get the dropdown list options
  getNokiaProductsListData = async (field: any,name: any) => {
    const url = name !== "" ? DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster + `/${name}` :
      DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productMaster;
    const params = field === "product_category_uuid" ? `?properties=${field}&group=${field}&format=list` :
      field === "identified_stock_type" ? `?properties=${field}&group=${field}&format=lookup`
        : `?properties=${field}&group=${field}&filters[status_text]=Active&format=list`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: url + params
    });
    return res.data;
  }



  ciqAcivityLog = async (data: any,status: any,accessToken: any,preCiqInformationSelector: any) => {
    //  const url = 'http://localhost:4000/workflow/ms-network-planner'
    const params = accessToken != null && !preCiqInformationSelector.internalShare ? `/activity-sync?_format=json&username=${this.email}&user_id=${preCiqInformationSelector.externalUser.user_id}&ciq_user_type=external` : `/activity-sync?_format=json&username=${this.email}`;
    const res = await axios({
      headers: {
        'operation': status,
      },
      method: "post",
      url: OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.ciqAcivityLog + params,
      data: data,
    });
    return res.data;
  };

  getFileConfigDetails = async (filter: any) => {
    const properties = `id,name,data_element,max_size,extensions,extension_status,status,allowed_tags`
    let params = `?properties=${properties}&limit=20`
    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }
    const res = await axios({
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.fileconfig + params,
    });
    return res.data;
  }

  getNetworkLifeCycleHistory = async (filter: any) => {
    const properties = `network_id`
    let params = `?properties=${properties}`
    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }
    const res = await axios({
      headers: {
        'milestone-history': true,
      },
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList + params,
    });
    return res.data;
  }

  getZendeskTicket = async (filter: any) => {
    let params = `?${filter}`
    const res = await axios({
      method: "get",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.zendeskTicket + params,
    });
    return res.data;
  }

  networkLifeCycleUpdate = async (data: any) => {
    //  const url = 'http://localhost:4000/workflow/network-lifecycle'
    const res = await axios({
      method: "post",
      // url: 'http://localhost:4000/workflow/network-lifecycle',
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.lifeCycyleUpdate,
      data: data,
    });
    return res.data;
  };

  getAccountDetailsForFrameAgreement = async (filter: any,limit: any = 10,offset: any = 0,one_star_id: any = [],requested_info: any,oneStarAccount: any,searchText: any) => {
    // console.log(filter, limit = 10, offset = 0, one_star_id = [], requested_info, oneStarAccount, searchText)
    const props = requested_info === "sell_to_party" ?
      ["account_id", "name", "status", "incoterms", "payment_terms", "accountnumber", "sap_address"]
      : ["account_id", "name", "status", "incoterms", "payment_terms", "address_info"];
    const bodyParams = {
      "properties": props,
      "filter": filter, //searchText !== "" ?filter + `AND name like '%${searchText}%'` : filter,
      "supplier_id": [],
      "limit": limit,
      "offset": offset,
      "one_star_id": []
    }
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read",
        'requested_info': requested_info
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.allAccounts,
      // url: `http://localhost:3000/v1/account`,
      data: bodyParams
    });
    return res.data;
  }

  getExternalUserAccessControlInfo = async (user_id: any,token: any) => {
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.user + `?token=${token}`;
    //const url = "http://localhost:4000/user"
    const response = await axios.get(url, {
      headers: {
        'x-user-id': user_id,
      },
    });
    return response.data
  }

  // Function to get product details for bundles
  getProductBundleDetails = async (params: any) => {
    // Destructre the params
    const { id, accountId: account_no, currency, detailType, compact_id_type } = params;

    let filter = `product_data.id ='${id}'`; // It is for MXIE product
    let crosserFilter = '';
    if (detailType === TYPE_OF_BUNDLE?.toLowerCase()) {
      crosserFilter = `compact_kits.compact_id = '${id}' and LOWER(compact_kits.compact_id_type) = '${compact_id_type}'`;
      filter = '';
    }
    let productBundleProperties = await this.getProductBundleProperties();
    // product properties
    const productProperties = [
      "pricelist_2_0.sap_account_id",
      "pricelist_2_0.account_description",
      "pricelist_2_0.price_amount",
      "pricelist_2_0.priceamount_currencycode",
      "product_data.id",
      "product_data.product_id",
      "product_data.product_category_description",
      "product_data.product_description",
      "product_data.product_family_id",
      "product_data.product_type_id",
      "product_data.product_sub_type_id",
      "pricelist_2_0.price_list",
      "product_data.product_lifecycle_status",
      "product_data.is_agent_model",
      "product_data.image_url",
      "product_data.is_marketplace",
      "supplier_master_sapbyd.supplier_text",
      "product_supplier_data.supplier_id",
      "supplier_master_sapbyd.address_info->>'$.data[0].country_region_id'",
      "product_details.product_specifications",
      "product_details.image_base_url",
      "product_data.fulfillment_mode",
      "product_data.product_sub_category",
      "product_data.nokia_tested",
      "product_data.product_category_id",
      // "product_data.supplier_id"     
      // Add the productBundleProperties
      ...productBundleProperties
    ]

    const formData = {
      properties: productProperties,
      filter,
      crosserFilter,
      limit: 20,
      offset: 0,
      hasDetails: true,
      includeCompactKits: true,
      "shippingCountry": store.getState()?.marketplace?.filters?.selection?.shippingCountry || null,
      detailType,
    }

    // const url = `${DATAMART_GLOBAL.baseUrl}${DATAMART_GLOBAL.endPoints.productsData}/details`;
    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const urlParams = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: url + urlParams,
      data: formData
    });
    res.data.data = this.modifyProductData(res.data.data)
    return res.data;
  }

  //network master related APIs
  getNetworkMasterListMarketPlace = async (limit: any = 10,offset: any = 0,filter: any = "",sortBy: any = "",sendAllowedValues: any, onlyNetworkId?: any) => {
    // let params = `?one_star_number=${one_star_number}`
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    // const apiUrl = 'https://ece-data-platform-dev.azurewebsites.net' + DATAMART_GLOBAL.endPoints.networkList
    const properties = `network_id`;
    // const params = `?properties=${properties}&limit=${limit}&offset=${offset}`;
    let params = sendAllowedValues == true ? `?properties=${properties}&field_allowed_values=true`
      : `?properties=${properties}`;

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    params += `&order_by=${sortBy}&limit=${limit}&offset=${offset}`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  esignPDF = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + "/v2/contract/esign"
    const res = await axios({
      method: "POST",
      url: apiUrl,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        "x-action": "esign-embed-url"
      }
    });
    return res.data;
  }

  esignCompleted = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + "/v2/contract/esign"
    const res = await axios({
      method: "POST",
      url: apiUrl,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        "x-action": "esign-completed"
      }
    });
    return res.data;
  }

  sendMeCopy = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + "/v2/contract/esign"
    const res = await axios({
      method: "POST",
      url: apiUrl,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        "x-action": "send-me-copy"
      }
    });
    return res.data;
  }

  esignSuccess = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + "/v2/contract/esign"
    const res = await axios({
      method: "POST",
      url: apiUrl,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        "operation": "esign-success"
      }
    });
    return res.data;
  }


  getAgreementStatus = async (agreementId: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + `/v2/contract/agreement-status/${agreementId}`
    const res = await axios({
      method: "GET",
      url: apiUrl,
      headers: {
        // remove JSON if set in axios.defaults or custom instance
      },
      transformRequest: (data, headers) => {
        delete headers["Content-Type"];
        return data;
      }
    });
    return res.data;
  }

  getValidMxieServers = async (params: any) => {
    const { mxieServerIds, accountId: account_no, currency } = params;

    let filter = `product_data.is_marketplace = 1 and product_data.id in (${mxieServerIds.map((id: any) => `'${id}'`).join(",")})`;

    const formData = {
      properties: ["product_data.id", "product_data.product_type_id"],
      filter,
      limit: 100,
      offset: 0,
    }

    const url = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.productsData;
    const urlParams = account_no !== null ? `?_format=json&account=${account_no}` : `?_format=json&account=${account_no}&currency=${currency}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: url + urlParams,
      data: formData
    });
    return res.data;
  }

  getOfferNetworkMasterList = async (filter: any = "",offset: any = 0,sortBy: any = "",limit: any = 100) => {
    // let params = `?one_star_number=${one_star_number}`
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    //const apiUrl = "http://localhost:4000/v2/network"
    const properties = `network_id,offer_id,core_offer_id`;
    // const params = `?properties=${properties}&limit=${limit}&offset=${offset}`;
    let params = `?properties=${properties}`

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    params += `&order_by=${sortBy}&limit=${limit}&offset=${offset}`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  getMerchantCustomerRules = async (shippingCountry: any) => {
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'operation': "read"
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + '/country',
      data: {
        is_merchant_customer_rule: true,
        filter: `(merchant_customer_rule.is_allowed_for_marketplace = 1 or merchant_customer_rule.is_allowed = 1) and merchant_customer_rule.customer_country_code = '${shippingCountry}'`
      }
    });
    return res.data;
  };

  getAgreementValidationDetails = async (one_star_number: any,bodyData: any) => {
    let params = `?one_star_number=${one_star_number}&validateAgreement=true`;
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.agreementData

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "post",
      url: apiUrl + params,
      data: bodyData,
    });

    return res.data;
  }

  getProcesses = async () => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getProcesses
    const properties = `id,name,machine_name,createdAt `;
    let params = `?properties=${properties}`
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  getProcessesConfig = async (machine_name: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getProcesses + `/${machine_name}/config`
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "get",
      url: apiUrl
    });

    return res.data;
  }
  getProcessesTasks = async (filter: any,limit: any,offset: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getTasks
    const properties = `id,process_id,entity_type,entity_id,status,state,priority,task_metadata,due_date,createdAt`;
    let params = `?properties=${properties}`
    params += `&filter=${filter}&limit=${limit}&offset=${offset}`
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        'include_assignees': true,
        'getcount': true
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  updateTaskData = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.getTasks
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
      },
      method: "put",
      url: apiUrl,
      data: payload
    });

    return res.data;
  }

  addAssigness = async (formData: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.processPta
    //const apiUrl = 'http://localhost:4000/workflow/process/pta'
    const res = await axios({
      method: "POST",
      url: apiUrl,
      data: formData,
      headers: {
        'x-user-id': this.userID,
      },
    });
    return res.data;
  }

  getTaskComments = async (task_id: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.taskComments
    let params = `?task_id=${task_id}`;
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  addEditTaskComments = async (formData: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.taskComments
    const res = await axios({
      method: formData.tc_id ? "PUT" : "POST",
      url: apiUrl,
      data: formData,
      headers: {
        'x-user-id': this.userID,
      },
    });
    return res.data;
  }

  getOfferNetworkMasterData = async (filter: any = "",offset: any = 0,sortBy: any = "",limit: any = 1) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.networkList
    const properties = `network_id,offer_id,core_offer_id,accountnumber,end_customer_accountnumber`;
    let params = `?properties=${properties}`

    if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }

    params += `&order_by=${sortBy}&limit=${limit}&offset=${offset}`;

    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  taskUpdateWorkflow = async (data: any) => {
    // const url = 'http://localhost:4000/workflow/task/save'taskSave
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.taskSave,
      data: data,
    });
    return res.data;
  };

  getptafields = async (data: any) => {
    let Url = OOT_GLOBAL.proxyUrl + OOT_GLOBAL.endPoints.ptaFields
    const params = `?email=${this.email}&username=${this.email}`
    const res = await axios({
      method: "post",
      url: Url + params,
      data: data,
    });
    return res.data;
  }

  //D2C APIS start

  getD2cFields = async (data: any) => {
    let Url = `${process.env.REACT_APP_DATAMART}${DATAMART_GLOBAL.endPoints.d2cFields}`
    const query = new URLSearchParams({
      email: this.email,
      username: this.email,
      ...(data || {}),
    }).toString();
    const res = await axios({
      method: "get",
      url: `${Url}?${query}`,
    });
    return res.data;
  }

  getD2cStoredData = async (offerId: any = '',d2cType: any = "ndac",networkId: any = "",sliceId: any = "") => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.processData;
    let filter = `entity_id='${networkId}' and name='D2C'`;
    filter += ` and JSON_EXTRACT(data,'$.meta.d2c_type')='${d2cType}'`;
    if (sliceId) {
      filter += ` and JSON_EXTRACT(data,'$.meta.slice_id')='${sliceId}'`;
    }
    if (offerId) {
      filter += ` and JSON_EXTRACT(data,'$.meta.offer_id')='${offerId}'`;
    }
    const params = `?properties=id,data,entity_id,name,status&filter=${encodeURIComponent(filter)}`;
    const res = await axios({
      method: "get",
      url: apiUrl + params,
      headers: {
        "x-user-id": this.userID,
      },
    });
    // Response: { status, data: [{ id, data: { meta, d2c_data }, entity_id, name }] }
    const rows = res.data?.data || [];
    if (rows.length > 0) {
      const rowData = typeof rows[0].data === "string" ? JSON.parse(rows[0].data) : rows[0].data;
      return {
        status: true,
        data: rowData,
        processDataId: rows[0]?.id != null ? String(rows[0].id) : undefined,
        workflowStatus: rows[0]?.status,
      };
    }
    return { status: true, data: null };
  }

  
  saveD2cCombined = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.saveD2c;
    const res = await axios({
      method: "post",
      url: apiUrl,
      headers: {
        "x-user-id": this.userID,
        "Content-Type": "application/json; charset=UTF-8",
      },
      data: payload,
    });
    return res.data;
  }

  signOffD2c = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.signOffD2c;
    const res = await axios({
      method: "post",
      url: apiUrl,
      headers: {
        "x-user-id": this.userID,
        "Content-Type": "application/json; charset=UTF-8",
      },
      data: payload,
    });
    return res.data;
  }

  handoverD2c = async (payload: any) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.handoverD2c;
    const res = await axios({
      method: "post",
      url: apiUrl,
      headers: {
        "x-user-id": this.userID,
        "Content-Type": "application/json; charset=UTF-8",
      },
      data: payload,
    });
    return res.data;
  }


  // New API method to check D2C status
  checkD2CStatus = async (network_ids: string[]) => {
    const payload = {
      "network_ids": network_ids
    };
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + "/v2/d2c/d2c_status",
      data: payload
    });
    return res.data;
  };

  
  //D2C APIS end

  salestoDeliveryPtaHandover = async (data: any,status: any) => {
    //  const url = 'http://localhost:4000/workflow/network-lifecycle'
    const res = await axios({
      headers: {
        'operation': status,
      },
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.pta,
      data: data,
    });
    return res.data;
  };
  
  getReassignDetails = async (serial_number: any,network_id: any)=>{
      const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.reassign
  
    let params = `?serial_number=${serial_number}&network_id=${network_id}`
    const res = await axios({
      headers: {
        'x-user-id': this.userID,
        // 'operation': operation
      },
      method: "get",
      url: apiUrl + params
    });

    return res.data;
  }

  addReassignNetwork = async(data: any)=>{
     const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.reassign,
      data: data,
    });
    return res.data;
  }
  
  getAssetsFileLists = async (filter: any,limit: any = 20,offset: any = 0,nextCursor: any = []) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.fileList
    const properties = `id,file_name,file_path,file_url,mime_type,destination_type,ui_name,data_element,accountnumber,end_customer_accountnumber,file_type_id,size,createdAt,created_by_email,created_by_name,name,folder_categories`;
    let params = `?properties=${properties}`
        if (filter && filter.trim() !== "") {
      params += `&filter=${filter}`; // no encodeURIComponent
    }
    params += `&limit=${limit}`;
    if(offset > 0 && nextCursor){
      const offsetValue = offset - limit;
      const currentCursor = nextCursor.find((item: any) => item?.offset === offsetValue)?.nextCursor || ""
      params += `&cursor=${currentCursor}`;
    }
    const res = await axios({
      headers: {
        'getcount': true
      },
      method: "get",
      url: apiUrl + params
    });
    return res.data;
  }

  getAssetsFileDownloadHistory = async (fileId: any,limit: any=0) => {
    const apiUrl = DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.filedownload
    const properties = `fu_log_id,fid,type,filename,downloaded_by,downloaded_by_email,downloaded_at,downloaded_by_name`;
    let params = `?properties=${properties}`
    params += `&key=${fileId}&limit=${limit}`;
    const res = await axios({
      method: "get",
      url: apiUrl + params
    });
    return res.data;
  }

  taskScstartUpdate = async (data: any) => {
    //  const url = 'http://localhost:4000/workflow/network-lifecycle'
    const res = await axios({
      method: "post",
      url: DATAMART_GLOBAL.baseUrl + DATAMART_GLOBAL.endPoints.scStartUpdate,
      data: data,
    });
    return res.data;
  };
  
}
const OOT = new OOT_API();
export default OOT;
